module.exports = __webpack_public_path__ + "static/media/gradient_background.2c7fecc1.png";